import { React, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import FetchModule from '../../Share/Network/FetchModule';

import DefaultLogoPath from '../../../image/DefaultLogo.png';
import UserProfile from '../../../Component/Normal/UserProfile';

export default function MemberInfo(props) {
  const { today } = props;

  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [reserveInfo, setReserveInfo] = useState([]);
  const [attendanceInfo, setAttendanceInfo] = useState([]);
  const [newInfo, setNewInfo] = useState([]);
  const [expiredInfo, setExpiredInfo] = useState([]);

  const reserveRef = useRef();
  const attendanceRef = useRef();
  const newRef = useRef();
  const expiredRef = useRef();

  useEffect(() => {
    const refs = [reserveRef, attendanceRef, newRef, expiredRef];
    const handlers = [];

    refs.forEach(ref => {
      const el = ref.current;
      if (!el) return;
      const handler = (e) => {
        if (el.scrollWidth <= el.clientWidth) return;
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        e.preventDefault();
        el.scrollLeft += e.deltaY * 0.5;
      };
      el.addEventListener('wheel', handler, { passive: false });
      handlers.push({ el, handler });
    });

    return () => {
      handlers.forEach(({ el, handler }) => el.removeEventListener('wheel', handler));
    };
  }, []);

  // 회원 정보 전체 불러오기 //
  useEffect(() => {
    let requestData = {
      standardDate: today.format('YYYY-MM-DDT23:59:59')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/today/status', 'POST', requestData);

        if (responseData.status === 200) {
          setReserveInfo(responseData.data.reserveInfos);
          setAttendanceInfo(responseData.data.attendanceInfos);
          setNewInfo(responseData.data.newInfos);
          setExpiredInfo(responseData.data.expiredInfos);
        }
        else if (responseData.status === 204) {}
      }
    )();
  }, [history, today])

  // 오늘 예약한 회원, 신규 등록회원 클릭시 //
  function onClickMemberImage(data) {
    history.push('/member/valid/detail/' + data.memberId);
  }

  return (
    <TopLevelWrapper $isDark={isDark}>
      <TitleWrapper>
        <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('main.member.title')}</Text>
        <ExplanationWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('main.member.desc')}</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.primary} cursor='pointer' onClick={() => history.push('/member/valid')}>{t('main.member.detail')}</Text>
        </ExplanationWrapper>
      </TitleWrapper>
      <TotalInfoWrapper>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default' style={{ marginTop: '24px' }}>{t('main.member.reservedToday')} ({reserveInfo.length})</Text>
        <MemberWrapper ref={reserveRef}>
          {
            reserveInfo.map((data, index) => (
              <InfoWrapper key={'ReserveInfos-' + index} onClick={() => history.push('/member/valid/detail/' + data.memberId + '/course')}>
                <MemberImage>
                  <UserProfile profile={data.profile} defaultProfile={DefaultLogoPath}/>
                </MemberImage>
                <MemberName>{data.name}</MemberName>
              </InfoWrapper>
            ))
          }
        </MemberWrapper>
      </TotalInfoWrapper>
      <TotalInfo2Wrapper>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default' style={{ marginTop: '24px' }}>{t('main.member.attendedToday')} ({attendanceInfo.length})</Text>
        <MemberWrapper ref={attendanceRef}>
          {
            attendanceInfo.map((data, index) => (
              <InfoWrapper key={'AttendanceInfos-' + index} onClick={() => onClickMemberImage(data)}>
                <MemberImage>
                  <UserProfile profile={data.profile} defaultProfile={DefaultLogoPath}/>
                </MemberImage>
                <MemberName>{data.name}</MemberName>
              </InfoWrapper>
            ))
          }
        </MemberWrapper>
      </TotalInfo2Wrapper>
      <TotalInfo2Wrapper>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default' style={{ marginTop: '24px' }}>{t('main.member.newMember')} ({newInfo.length})</Text>
        <MemberWrapper ref={newRef}>
          {
            newInfo.map((data, index) => (
              <InfoWrapper key={'NewInfos-' + index} onClick={() => onClickMemberImage(data)}>
                <MemberImage>
                  <UserProfile profile={data.profile} defaultProfile={DefaultLogoPath}/>
                </MemberImage>
                <MemberName>{data.name}</MemberName>
              </InfoWrapper>
            ))
          }
        </MemberWrapper>
      </TotalInfo2Wrapper>
      <TotalInfo2Wrapper>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default' style={{ marginTop: '24px' }}>{t('main.member.expiredMember')} ({expiredInfo.length})</Text>
        <MemberWrapper ref={expiredRef}>
          {
            expiredInfo.map((data, index) => (
              <InfoWrapper key={'ExpiredInfos-' + index} onClick={() => onClickMemberImage(data)}>
                <MemberImage>
                  <UserProfile profile={data.profile} defaultProfile={DefaultLogoPath}/>
                </MemberImage>
                <MemberName>{data.name}</MemberName>
              </InfoWrapper>
            ))
          }
        </MemberWrapper>
      </TotalInfo2Wrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 404px;
  height: 767px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: 4px;

  gap: 93px;
`;

const TotalInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 24px;

  width: 348px;
  height: 164px;

  border-top: 2px solid ${props => props.theme.line};
`;

const TotalInfo2Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 348px;
  height: 166px;

  overflow: hidden;
`;

const MemberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding-top: 24px;
  padding-left: 16px;
  padding-right: 16px;
  gap: 12px;

  height: 96px;

  overflow-x: scroll;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar};
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(
      to bottom,
      transparent 1px,
      ${props => props.theme.line} 1px,
      ${props => props.theme.line} 2px,
      transparent 2px
    );
    border-radius: 200px;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
`;

const MemberImage = styled.div`
  width: 48px;
  height: 48px;

  border-radius: 48px;

  overflow: hidden;

  transition: all 0.3s ease-in-out;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    cursor: pointer;
    filter: drop-shadow(0px 0px 8px #FF8B48);

    img {
      transform: scale(1.1);
    }
  }
`;

const MemberName = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 10px;

  color: ${props => props.theme.text};

  margin: 10px 0 24px 0;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
